module.exports = __webpack_public_path__ + "img/logo.bc75978b.png";